import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1822">
      <Hero data-id="element-1823" />
      <WhyUs data-id="element-1824" />
      <Services data-id="element-1825" />
      <HowItWorks data-id="element-1826" />
      <FAQ data-id="element-1827" />
      <Reviews data-id="element-1828" />
      <CtaBanner data-id="element-1829" />
    </main>;
}